import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string;
  noindex?: boolean;
  structuredData?: Record<string, unknown>;
}

export const SEO = ({
  title = 'Lyder Talk - AI-Powered Speaking Practice',
  description = 'Generate topics, questions, and vocabulary for speaking practice with AI. Perfect for language learners and conversation practice.',
  image = '/og-image.png',
  url = 'https://lydertalk.com',
  type = 'website',
  keywords = 'language learning, speaking practice, AI language tutor, conversation practice, English speaking, language learning app',
  noindex = false,
  structuredData,
}: SEOProps) => {
  const fullTitle = title.includes('Lyder Talk') ? title : `${title} | Lyder Talk`;
  const fullUrl = url.startsWith('http') ? url : `https://lydertalk.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://lydertalk.com${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Lyder Talk" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}

      {/* Additional SEO */}
      <meta name="theme-color" content="#000000" />
    </Helmet>
  );
};

